export default __webpack_public_path__ + "static/brushOff-fb3e81b66b6e56a8b6af8b2634575d74.svg";